import { BankCardsFilters, BankCardsParameters } from '@/bank/bank.model';
import { Component, Input } from '@angular/core';
import { FiltersComponent } from 'src/app/common/filters.component';

@Component({
	selector: 'app-bank-cards-filters',
	templateUrl: './bank-cards-filters.component.html',
	styleUrls: ['./bank-cards-filters.component.scss'],
})
export class BankCardsFiltersComponent extends FiltersComponent {
	@Input() paramFilters: BankCardsParameters;

	filters: BankCardsFilters = {
		status: null,
		currentOwnerId: null,
	};
}
